import { render } from "./ToolbarCardComponent.vue?vue&type=template&id=754e8d24&scoped=true"
import script from "./ToolbarCardComponent.vue?vue&type=script&lang=js"
export * from "./ToolbarCardComponent.vue?vue&type=script&lang=js"

import "./ToolbarCardComponent.vue?vue&type=style&index=0&id=754e8d24&lang=scss&scoped=true"

import exportComponent from "/home/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754e8d24"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
